/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */
import * as References from './UsersRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#getUserIdsOnHubByRoleIdAndPendingStatus
 */
export const GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_getUserIdsOnHubByRoleIdAndPendingStatus';
export const GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY_FIELD_NAME,
  args: ['roleId', 'includePending', 'includeInactive'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUserIdsOnHubByRoleIdAndPendingStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#filterOutInvisibleUsers
 */
export const FILTER_OUT_INVISIBLE_USERS_QUERY_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_filterOutInvisibleUsers';
export const FILTER_OUT_INVISIBLE_USERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FILTER_OUT_INVISIBLE_USERS_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.filterOutInvisibleUsersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#getUsersByIds
 */
export const GET_USERS_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_getUsersByIds';
export const GET_USERS_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USERS_BY_IDS_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getUsersByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#setUserPermissions
 */
export const SET_USER_PERMISSIONS_MUTATION_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_setUserPermissions';
export const SET_USER_PERMISSIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_USER_PERMISSIONS_MUTATION_FIELD_NAME,
  args: ['rolesByUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.setUserPermissionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#setUserPermissionsAndSeats
 */
export const SET_USER_PERMISSIONS_AND_SEATS_MUTATION_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_setUserPermissionsAndSeats';
export const SET_USER_PERMISSIONS_AND_SEATS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_USER_PERMISSIONS_AND_SEATS_MUTATION_FIELD_NAME,
  args: ['rolesAndSeatsByUserId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.setUserPermissionsAndSeatsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#addUserBulk
 */
export const ADD_USER_BULK_MUTATION_FIELD_NAME = 'com_hubspot_appusers_rpc_UsersRpc_addUserBulk';
export const ADD_USER_BULK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_USER_BULK_MUTATION_FIELD_NAME,
  args: ['users', 'roleNames', 'seatNames', 'teamId', 'secondaryTeamIds', 'permissionSetIds', 'presetId', 'sendWelcomeEmail', 'sendSlackInvite', 'forceWelcomeEmail', 'customMessage'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.addUserBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});